import { Heart, Moon, Pencil } from "lucide-react";
import { Reveal } from "../components/motion";

const PLACEHOLDERS = [
  { title: "Why Bedtime Buddies was created", text: "[ Founder's note goes here — the bedtime moment that started it all. This section is ready for your real story. ]" },
  { title: "The Halo inspiration", text: "[ The story of Halo and the family inspiration behind the brand. Replace this placeholder with your own words and photos. ]" },
  { title: "Building the first Buddy", text: "[ The product-development journey — sketches, prototypes, fabric choices and the first glowing belly. ]" },
];

export default function OurStory() {
  return (
    <div data-testid="our-story-page" className="bg-cream">
      <section className="px-6 py-20 text-center lg:py-28">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">Our story</p>
          <h1 className="mx-auto mt-5 max-w-3xl font-display text-4xl font-medium leading-tight text-navy sm:text-5xl">
            It started with “one more hug.”
          </h1>
        </Reveal>
      </section>

      <section className="mx-auto max-w-3xl px-6 pb-10">
        <Reveal>
          <div className="rounded-[2.5rem] bg-blush p-10 text-center" data-testid="mission-statement">
            <Moon className="mx-auto text-pink" size={28} />
            <p className="mt-5 font-display text-2xl font-medium leading-snug text-navy sm:text-3xl">
              To make bedtime feel a little warmer, friendlier and less lonely for kids everywhere.
            </p>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">Our mission</p>
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-3xl space-y-5 px-6 py-14">
        {PLACEHOLDERS.map((p, i) => (
          <Reveal key={p.title} delay={0.05 * i}>
            <div className="rounded-[2rem] border border-dashed border-lavdeep/60 bg-white p-8" data-testid={`story-placeholder-${i}`}>
              <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-navy/35">
                <Pencil size={12} /> Editable placeholder
              </p>
              <h2 className="mt-3 font-display text-2xl font-semibold text-navy">{p.title}</h2>
              <p className="mt-3 text-base italic leading-relaxed text-navy/45">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="px-6 pb-24 text-center">
        <Reveal>
          <p className="mx-auto flex max-w-md items-center justify-center gap-2 font-display text-xl text-navy/70">
            <Heart size={18} className="text-pink" fill="#F58CC8" /> Made by parents, for parents — and the kids who ask for one more hug.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
